import { render, staticRenderFns } from "./EmailChangeToken.vue?vue&type=template&id=6c9f96f4&scoped=true&"
import script from "./EmailChangeToken.vue?vue&type=script&lang=js&"
export * from "./EmailChangeToken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9f96f4",
  null
  
)

export default component.exports